import { html } from 'fxjs/es';
import { hasPdfFile } from '../Function/mobilepdfuploader.js';

/**
 * @param {PdfPrintingFileRow | undefined} pdf_printing_file
 * @return {string} PDF 업로드 프레임 헤더 HTML 문자열
 * */
export function header({ pdf_printing_file }) {
  const has_pdf_file = hasPdfFile({ pdf_printing_file });

  return html`<div class="pdf_uploader__header">
    <button class="fs-12 fw-400 lh-100" name="cancel">${TT('pdf::uploader::18')}</button>
    <span class="title fs-14 fw-700">${TT('pdf::uploader::0')}</span>
    <button class="fs-12 fw-400 lh-100" name="confirm" ${has_pdf_file ? '' : 'disabled'}>
      ${TT('pdf::uploader::19')}
    </button>
  </div>`;
}
